import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=6d377042&"
import script from "./Faq.vue?vue&type=script&lang=ts&"
export * from "./Faq.vue?vue&type=script&lang=ts&"
import style0 from "./Faq.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports